const leads = {
  name: 'Lead |||| Leads',
  fields: {
    firstName: 'First name',
    lastName: 'Last name',
    treatment: 'Treatment',
    email: 'Email',
    secondaryEmail: 'Secondary email',
    mobilePhone: 'Mobile phone',
    landlinePhone: 'Landline phone',
    city: 'City',
    region: 'Region',
    country: 'Country',
    status: 'Status',
    preferredLanguage: 'Preferred language',
    acceptsNewsletter: 'Accepts newsletter',
    notes: 'Notes',
    hotelName: 'Hotel',
    lastContactDate: 'Last contact',
    nextContactDate: 'Next contact',
    isArchived: 'Archived',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    personalMobilePhone: 'Personal mobile',
    phoneExtension: 'Extension',
    address: 'Address',
    linkedInUrl: 'LinkedIn',
    website: 'Website',
    consentDate: 'Consent date',
    consentOrigin: 'Consent origin',
    companyName: 'Company',
    jobTitleName: 'Job title',
    contactTypeName: 'Contact type',
    leadSourceName: 'Source',
    hotelChainName: 'Own chain',
    effectiveChainName: 'Chain',
    hotelCategoryName: 'Hotel category',
    hotelPmsSystemName: 'PMS',
    hotelLockSystemName: 'Lock system',
    hotelPaymentProcessorName: 'Payment proc.',
    tagNames: 'Tags',
    interestNames: 'Interests',
  },
  filters: {
    archived: 'Archived',
    includeArchived: 'Include archived',
    searchNotes: 'Also search in notes',
    fieldFilters: 'Field filters',
    company: 'Company (contains)',
    hotel: 'Hotel (contains)',
    emailDomainsInclude: 'Email domain (include)',
    emailDomainsExclude: 'Email domain (exclude)',
    domainsHelp: 'Separate multiple domains with commas',
    countries: 'Countries',
    regions: 'Regions / Provinces',
    jobTitles: 'Job titles',
    contactType: 'Contact type',
    leadSource: 'Source',
    chains: 'Chains',
    individualHotels: 'Individual hotels (no chain)',
    chainMinHotels: 'Chain with minimum hotels',
    pmsSystems: 'PMS',
    lockSystems: 'Lock systems',
    paymentProcessors: 'Payment processors',
    hotelCategories: 'Hotel categories',
    status: 'Status',
    language: 'Preferred language',
    newsletter: 'Newsletter',
    newsletterYes: 'Yes',
    newsletterNo: 'No',
    tags: 'Tags',
    tagMode: 'Tag mode',
    interests: 'Interests',
    interestMode: 'Interest mode',
    modeAll: 'All (AND)',
    modeAny: 'Any (OR)',
    lastContactFrom: 'Last contact from',
    lastContactTo: 'Last contact to',
    nextContactFrom: 'Next contact from',
    nextContactTo: 'Next contact to',
  },
  sections: {
    basicInfo: 'Basic information',
    contactInfo: 'Contact information',
    location: 'Address',
    classification: 'Classification',
    crm: 'Follow-up and consent',
    tagsInterests: 'Tags and interests',
  },
  tabs: {
    personal: 'Personal',
    contact: 'Contact',
    address: 'Address',
    crm: 'CRM',
    tags: 'Tags',
    interests: 'Interests',
    notes: 'Notes',
  },
  actions: {
    archive: 'Archive',
    restore: 'Restore',
  },
  newsletter: {
    button: 'Send newsletter',
    title: 'Send newsletter',
    funnel: 'With the current filters: %{total} leads, %{withEmail} with email, %{optIn} accept the newsletter.',
    loadingPreview: 'Computing recipients…',
    onlyOptIn: 'Send only to newsletter opt-ins (GDPR)',
    template: 'Template',
    noTemplate: '(no template — compose below)',
    subject: 'Subject',
    body: 'Message body',
    placeholdersHelp: 'Available variables: {nombre} {apellidos} {tratamiento} {empresa} {hotel} {cargo} {ciudad} {pais} {email}',
    inlineRequired: 'Enter the subject and the message body',
    confirm: '"%{what}" will be sent to %{count} recipients. Continue?',
    send: 'Send (%{count})',
    result: 'Sent: %{sent} · Failed: %{failed} · No email: %{skipped}',
    error: 'The send could not be completed',
  },
  bulk: {
    groupEdit: 'Group edit',
    purge: 'Delete permanently',
    title: 'Group edit (%{count} leads)',
    fieldsSection: 'Direct fields (check the ones to modify; empty = clear the value)',
    setsSection: 'Tags and interests',
    hotelAttrsSection: 'Hotel attributes',
    hotelAttrsWarning:
      'Warning: these changes apply to the hotels of the selected leads and also affect every other lead of those hotels.',
    modeNone: 'Do not change',
    modeAdd: 'Add',
    modeRemove: 'Remove',
    modeReplace: 'Replace',
    apply: 'Apply changes',
    confirm: 'The changes (%{operations}) will be applied to %{count} leads. Continue?',
    archiveConfirm: 'Archive %{count} leads?',
    purgeConfirm:
      'WARNING: %{count} leads will be permanently deleted. This cannot be undone. Continue?',
    done: 'Operation applied to %{count} leads',
    hotelAttrsDone: 'Attributes updated on %{hotels} hotels (%{leads} leads affected)',
    summaryFields: 'direct fields',
    summaryTags: 'tags',
    summaryInterests: 'interests',
    summaryHotelAttrs: 'hotel attributes',
    error: 'The operation could not be completed',
  },
  messages: {
    created: 'Lead created successfully',
    updated: 'Lead updated successfully',
    archived: 'Lead archived successfully',
    restored: 'Lead restored successfully',
    duplicateEmail:
      'Another contact (%{name}) already uses this email. Save anyway?',
  },
  edit: {
    title: 'Edit lead',
  },
  create: {
    title: 'Create lead',
  },
  help: {
    editBanner:
      'Edit the lead details below. Required fields are marked with an asterisk.',
    createBanner:
      'Enter at least a name or an email to create the lead. The rest of the details are completed from the edit page.',
  },
  empty: 'No leads found',
  invite: 'Create your first lead',
};

export default leads;
